module.exports = __webpack_public_path__ + "img/streamMedia_architecture_img.ecd71fb8.png";